import { Dialog } from "@mui/material";
import { useScale } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import I18n from "features/shared/i18n";

interface NotificationData {
  date: string;
  title: string;
  content: string;
}

interface NotificationDetailModalProps {
  open: boolean;
  notification: NotificationData | null;
  onClose: () => void;
}

export const NotificationDetailModal = ({
  open,
  notification,
  onClose,
}: NotificationDetailModalProps) => {
  const { width, scale } = useScale();
  // 狭い画面（scale下限クランプ時）でも収まるよう、設計幅を上限に可変にする
  const modalWidth = Math.min(1000, width / scale - 16);

  if (!notification) return null;

  return (
    <Dialog
      fullScreen
      open={open}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div
            style={{ width: modalWidth }}
            className="flex-col-el border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30"
          >
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white">
              <ParentCloseBtn close={onClose} />
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">
                  notifications
                </span>
                <h2 className="text-[33px] text-textcolor-black">
                  {I18n.t("MSG_NOTIFICATION_DEFAULT_TITLE")}
                </h2>
              </div>

              <div className="flex-col-el gap-4 max-h-[500px] overflow-y-auto invisible-scrollbar">
                {/* 日付 */}
                <div className="flex-row-el">
                  <span className="text-[18px] text-gray2-100 bg-gray2-20 px-3 py-1 rounded-[8px]">
                    {notification.date}
                  </span>
                </div>

                {/* タイトル */}
                <h3 className="text-[24px] text-textcolor-black leading-[1.4]">
                  {notification.title}
                </h3>

                {/* 本文 */}
                <div className="flex-col-el gap-3">
                  {notification.content.split("\n").map((paragraph, index) => (
                    <p
                      key={index}
                      className="text-body text-[24px] text-textcolor-black leading-[1.6]"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
